module.exports = __webpack_public_path__ + "static/media/07.8c37bc2a.jpg";